import { render, staticRenderFns } from "./SupplierGroup.vue?vue&type=template&id=4021ffb0&scoped=true"
import script from "./SupplierGroup.vue?vue&type=script&lang=js"
export * from "./SupplierGroup.vue?vue&type=script&lang=js"
import style0 from "./SupplierGroup.vue?vue&type=style&index=0&id=4021ffb0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4021ffb0",
  null
  
)

export default component.exports